import { setBorderAttr } from 'common/Prose/Commands/table/mutation'
import { type EditorView } from 'prosemirror-view'
import { CELL_BORDER_COLOR_OPTIONS } from '../../constants/colorOptions'
import { EditorColorPicker } from '../EditorColorPicker/EditorColorPicker'

interface Props {
  closePicker?: () => void
  includeDropdownStyles?: boolean
  view: EditorView
  focusView?: boolean
}

export const TableBorderColorPicker = ({
  closePicker,
  includeDropdownStyles = true,
  view,
  focusView = true,
}: Props) => {
  const activeColors: string[] = []

  const setColor = (color: string) => {
    setBorderAttr({ color })(view.state, view.dispatch)
    closePicker?.()
    if (focusView) view.focus()
  }

  return (
    <EditorColorPicker
      activeColors={activeColors}
      aria-label={(color) => `Change border color to ${color}`}
      colorOptions={CELL_BORDER_COLOR_OPTIONS}
      includeDropdownStyles={includeDropdownStyles}
      setColor={setColor}
      stopPropagation={false}
    />
  )
}
